import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import globalStore from './store';

const renderWithStore = (Component, element, store = null) => {
	render(
		<Provider store={store ?? globalStore}>
			{Component}
		</Provider>,
		element
	);
};

export default renderWithStore;
